export const HIGHLIGHTVARIANTS = ["primary", "light", "dark"];
